import React from "react";
import { WEB_URL } from "../../../lib/constants/globalConstant";
import { commonLayoutStyles as styles } from "./commonLayout.tailwind";

// Renders content dynamically for Privacy Policy, Cookie Policy, or Terms and Conditions pages based on provided data.
const CommonLayout = ({ data }) => {
  return (
    <section className={styles.section} style={{ fontFamily: "Arial" }}>
      <div className={styles.headingContainer}>

        {/* Page Heading */}
        <h1 className={styles.heading}> {data.title} </h1>
      </div>

      <div className="container">
        <p className={styles.commonDescription}>
          {/*Welcome Message */}
          <span> Welcome to our website{" "} <a href={WEB_URL} className="text-secondaryRed"> {WEB_URL} </a>. </span>

          {/* Updated On Section */}
          <span> <strong>Last Updated On:</strong> {data.updatedOn} </span>
        </p>

        {/* Page Description */}
        <p className="text-sm mb-6" dangerouslySetInnerHTML={{ __html: data.description }} />

        {/* data is traversed and each section(point) is rendered. In the data file sections is an array of the points */}
        {data.sections.map((section, index) => (
          <div key={index} className="mb-6">

            {/* Points Heading */}
            <h2 className={styles.listHeading}>{section.title} </h2>

            {/* Points Description */}
            {section.content && (
              <p className={styles.content} dangerouslySetInnerHTML={{ __html: section.content }} />
            )}

            {/* Points List */}
            {section.list && (
              <ul className={styles.list}>
                {section.list.map((item, idx) => (
                  <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </ul>
            )}

            {/* Sub Content of points */}
            {section.subContent && (
              <p className="text-sm mt-4" dangerouslySetInnerHTML={{ __html: section.subContent }} />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CommonLayout;
